import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Project } from '../../models/project';
import { Constants } from '../../utils/constants';
import { CustomTabMenuItem } from '../../models/custom-tab-menu-item';
import { UserLogicService } from '../../services/user.logic.service';

@Component({
  selector: 'app-tab-menu',
  templateUrl: './tab-menu.component.html',
  styleUrls: ['./tab-menu.component.css']
})
export class TabMenuComponent implements OnChanges {
  private userService: UserLogicService = inject(UserLogicService)
  @Input() items: CustomTabMenuItem[] = [];
  @Input() selectedProject?: Project;
  @Input() selectedProjectStatus?: number;
  @Input() isSetupValid: boolean = false;
  @Input() activeItem: MenuItem | undefined;
  @Input() isESAUDL:boolean = false;
  isProjectOwnedByUser: boolean = false;

  usingNumericIcons = true;

  @Output() onActiveIndexChangeEvent = new EventEmitter<MenuItem>();

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['items'])
    {
      this.usingNumericIcons = this.items.filter(item => item.visible).some(item=> item.useNumberIcon);
      this.usingNumericIcons ? this.setNumericIcons() : this.setColorFormat()
    }
    if(changes[Constants.SELECTED_PROJECT])
    {
      this.validateSelectedProject();
    }
    if (changes[Constants.IS_SETUP_VALID]) {
      this.validateSetup();
    }
    if (changes[Constants.SELECTED_PROJECT_STATUS]) {
      this.validateSelectedProject();
    }
  }

  setColorFormat(){
    this.items = this.items.map((item) => {
      item.styleIndex = `background: none; background-color: unset !important; color: #707070 !important;`
      return item;
    });

  }

  setNumericIcons(){
    let counter = this.items.length;
    this.items = this.items.filter(item => item.visible).map((item, index) => {
      const number = index + 1
      item.icon = `counter_${number}`;
      item.styleIndex = `z-index: 9${counter}`
      counter--;
      return item;
    });
  }

  onActiveItemChange(item: MenuItem)
  {
    this.onActiveIndexChangeEvent.emit(item);
  }

  validateSelectedProject() {
    if (this.selectedProject) {
      const originalItems = [...this.items];
      let setupItem = originalItems.find(x => x.label === Constants.EEA_MENU_LABELS.Setup);
      if (setupItem)
        setupItem.disabled = false;
      this.items = originalItems;
      this.validateRunProjectTab();
    }
  }

  validateSetup() {
    const originalItems = [...this.items];
    originalItems.map(item => {
      if (this.isESAUDL && item.label?.localeCompare("Setup", undefined, { sensitivity: 'base' }) === 0){
        return item;
      }
      item.disabled = !this.isSetupValid;
      return item;
    });
    this.items = originalItems;
    this.validateRunProjectTab();
  }

  validateRunProjectTab(): void {
    const originalItems = [...this.items];
    this.validateProjectOwnership();
    let runProjectItem = originalItems.find(x => x.label === Constants.EEA_MENU_LABELS.Run_Project);
    
    if (runProjectItem)
      runProjectItem.disabled = this.isESAUDL 
        ? (this.selectedProject && (this.selectedProject.status === Constants.PROJECT_STATUS_ID.IN_PROGRESS || this.selectedProject.status === Constants.PROJECT_STATUS_ID.IN_QUEUE)) || !this.isSetupValid || !this.isProjectOwnedByUser
        : (this.selectedProject && (this.selectedProject.status === Constants.PROJECT_STATUS_ID.IN_PROGRESS || this.selectedProject.status === Constants.PROJECT_STATUS_ID.IN_QUEUE)) || !this.isSetupValid;
    
    this.items = originalItems;
  }

  validateProjectOwnership(){
    this.isProjectOwnedByUser = this.userService.verifyProjectOwnership(this.selectedProject?.createdBy);
  }
}
